<script setup lang="ts">
import skeletonBoxStyles from '@/assets/sass/components/skeleton-box.module.scss';
import skeletonStyles from '@/assets/sass/utilities/skeletons.module.scss';

interface Props {
    width?: string | null;
    height?: string | null;
}

withDefaults(defineProps<Props>(), {
    width: '100%',
    height: '1em',
});
</script>

<template>
    <div :class="[skeletonBoxStyles.skeletonBox, skeletonStyles.shimmer]"
        :style="{ width: width ?? undefined, height: height ?? undefined }"></div>
</template>
